/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Add,
  ArrowLeft
} from "@mui/icons-material";
import {
  Button,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography
} from "@mui/material";
import moment from "moment";
import Page from "src/components/Page";
import { fetchNotificationList } from "src/utils/common";
import { notification } from "src/utils/messages";
import {
  batchInsertNotification,
  updateNotification,
  deleteNotification,
  getReadNotificationData,
  getNotificationChildren,
  getNotificationByBatch
} from "src/api/commonapi";
import Deletemodal from "./DeleteModal";
import { CSVLink } from "react-csv";

import NotificationFilters from "./Notification/NotificationFilters";
import NotificationTable from "./Notification/NotificationTable";
import ReadNotificationModal from "./Notification/ReadNotificationModal";
import NotificationForm from "./Notification/NotificationForm";
import DeleteConfirmDialog from "./Notification/DeleteConfirmDialog";

function Notification() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  // --- State ---
  const [page, setPage] = useState(0); // 0=list, 1=add, 2=edit
  const [notificationList, setNotificationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [response, setresponse] = useState(0);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);

  // Form state
  const [formData, setFormData] = useState({});
  const [setfile, setFile] = useState({});
  const [fileimage, setfileimage] = useState();

  // Server-side filter state
  const [filtereddata, setFilteredData] = useState({
    notificationFor: -1,
    notificationStatus: 0,
    notificationType: -1,
    search: ""
  });

  // Pagination state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalRecords: 0,
    totalPages: 0
  });

  // Delete modal state
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });

  // Read notification modal
  const [readNotificationDataModal, setReadNotificationDataModal] = useState(false);
  const [readNotificationList, setReadNotificationList] = useState([]);

  // Delete confirm dialog
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deletingRow, setDeletingRow] = useState(null);
  const [subCount, setSubCount] = useState(0);
  const [scheduleReadOnly, setScheduleReadOnly] = useState(false);
  const [removeSubIds, setRemoveSubIds] = useState([]);
  const [siblingHasImmediate, setSiblingHasImmediate] = useState(false);

  // --- Constants ---
  const showOnHome = ["Off", "On"];
  const selectType = ["Photo", "Audio", "Video", "Question and Answer"];
  const notificationSendTo = ["All", "LT", "Members"];
  const notificationFor = ["LVB", "State", "City", "Chapter"];
  const notificationTo = [
    "All",
    "Not OBT (New Member)",
    "Not Green Tick (OBT Done)",
    "Not Blue Tick (V2V Done)",
    "Not Fillup V2V Sheet",
    "Location Not Set",
    "Blue Tick Done"
  ];

  // --- Initial Form Data ---
  const getDefaultFormData = () => ({
    n_title: "",
    n_description: "<p></p>",
    n_link: "",
    n_button_title: "",
    n_image: "",
    n_video: "",
    n_question: "",
    n_answer: "",
    n_type: "0",
    n_send_to: "0",
    n_for_type: "0",
    n_to: "0",
    n_for_id: "0",
    n_status: "1",
    show_on_home: 0,
    schedule_entries: [
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}`
      }
    ]
  });

  // --- API Calls ---
  const getNotificationList = async (filters = {}, page = 1, limit = 10) => {
    setIsLoading(true);
    const result = await fetchNotificationList(loginUser.city_id, loginUser.u_type, {
      ...filters,
      page,
      limit
    });
    setNotificationList(result.data || []);
    const p = result.pagination || {};
    setPagination({
      currentPage: p.current_page || p.currentPage || 1,
      perPage: p.per_page || p.perPage || 10,
      totalRecords: p.total_records || p.totalRecords || 0,
      totalPages: p.total_pages || p.totalPages || 0
    });
    setIsLoading(false);
  };

  useEffect(() => {
    getNotificationList({
      n_for_type: filtereddata.notificationFor,
      n_type: filtereddata.notificationType,
      notification_status: filtereddata.notificationStatus,
      search: filtereddata.search
    }, pagination.currentPage, pagination.perPage);
  }, [response, filtereddata]);

  // --- Pagination ---
  const handlePageChange = (newPage) => {
    setPagination((prev) => ({ ...prev, currentPage: newPage }));
    getNotificationList({
      n_for_type: filtereddata.notificationFor,
      n_type: filtereddata.notificationType,
      notification_status: filtereddata.notificationStatus,
      search: filtereddata.search
    }, newPage, pagination.perPage);
  };

  const handlePerRowsChange = async (newPerPage, newPage) => {
    setPagination((prev) => ({ ...prev, perPage: newPerPage, currentPage: newPage }));
    getNotificationList({
      n_for_type: filtereddata.notificationFor,
      n_type: filtereddata.notificationType,
      notification_status: filtereddata.notificationStatus,
      search: filtereddata.search
    }, newPage, newPerPage);
  };

  // --- Validation ---
  const validateScheduleEntries = (entries) => {
    if (!entries || entries.length === 0) {
      notification({ type: "error", message: "At least one schedule entry is required.", position: "top" })();
      return false;
    }

    const immediateCount = entries.filter(
      (e) => e.notification_send_type === "1" || e.notification_send_type === 1
    ).length;
    if (immediateCount > 1) {
      notification({ type: "error", message: "Only one entry can be 'Send Immediately' per batch.", position: "top" })();
      return false;
    }

    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      if (!entry.s_date) {
        notification({ type: "error", message: `Entry ${i + 1}: Start Date is required.`, position: "top" })();
        return false;
      }
      if (!entry.e_date) {
        notification({ type: "error", message: `Entry ${i + 1}: End Date is required.`, position: "top" })();
        return false;
      }
      if (
        moment(entry.e_date, "DD-MM-YYYY").isBefore(moment(entry.s_date, "DD-MM-YYYY"))
      ) {
        notification({ type: "error", message: `Entry ${i + 1}: End Date cannot be before Start Date.`, position: "top" })();
        return false;
      }
      if (
        entry.notification_send_type === "0" &&
        entry.n_date_time
      ) {
        const dt = moment(entry.n_date_time, "DD-MM-YYYY hh:mm A");
        const start = moment(entry.s_date, "DD-MM-YYYY").startOf("day");
        const end = moment(entry.e_date, "DD-MM-YYYY").endOf("day");
        if (!dt.isSameOrAfter(start) || !dt.isSameOrBefore(end)) {
          notification({
            type: "error",
            message: `Entry ${i + 1}: Send Date & Time must be between Start Date and End Date.`,
            position: "top"
          })();
          return false;
        }
      }
      if (
        (entry.notification_send_type === "0" || entry.notification_send_type === 0) &&
        !entry.n_date_time
      ) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: Notification Send Date & Time is required for scheduled entries.`,
          position: "top"
        })();
        return false;
      }
    }
    return true;
  };

  // CKEditor stores HTML — "<p></p>", "<p>&nbsp;</p>" etc. look empty but aren't "".
  const isRichTextEmpty = (html) => {
    if (html === null || html === undefined) return true;
    const text = String(html)
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/ /g, " ")
      .trim();
    return text === "";
  };

  const validationHandler = async () => {
    // Validate schedule entries
    if (!validateScheduleEntries(formData.schedule_entries)) return;

    // Validate type-specific fields
    if (formData.n_type == 0 || formData.n_type == 1) {
      let fileExtension = "";
      if (formData.n_image) fileExtension = formData.n_image.split(".").pop().toLowerCase();
      let isValidFile = false;
      if (formData.n_type == 0) isValidFile = imageTypes.includes(fileExtension);
      else if (formData.n_type == 1) isValidFile = videoTypes.includes(fileExtension);

      const missingFile = !isValidFile && (setfile == "" || Object.keys(setfile).length === 0);
      const missingTitle = (formData.n_title || "").trim() == "";
      const missingDesc = isRichTextEmpty(formData.n_description);
      if (missingFile || missingTitle || missingDesc) {
        const msg = missingTitle
          ? "Please enter Title"
          : missingDesc
            ? "Please enter Description"
            : "Please upload file";
        notification({ type: "error", message: msg, position: "top" })();
        return;
      }
    } else if (formData.n_type == 2) {
      if ((formData.n_title || "").trim() == "") {
        notification({ type: "error", message: "Please enter Title", position: "top" })();
        return;
      }
      if (isRichTextEmpty(formData.n_description)) {
        notification({ type: "error", message: "Please enter Description", position: "top" })();
        return;
      }
      if (formData.n_video == "") {
        notification({ type: "error", message: "Please enter Video URL", position: "top" })();
        return;
      }
      if (getYoutubeVideoId(formData?.n_video) == null) {
        notification({ type: "error", message: "Please enter a valid YouTube URL", position: "top" })();
        return;
      }
    } else if (formData.n_type == 3) {
      if ((formData.n_question || "").trim() == "") {
        notification({ type: "error", message: "Please enter Question", position: "top" })();
        return;
      }
      if (isRichTextEmpty(formData.n_answer)) {
        notification({ type: "error", message: "Please enter Answer", position: "top" })();
        return;
      }
    }
    // Validate targeting
    if (
      formData.n_send_to === null || formData.n_send_to === undefined ||
      formData.n_for_type === null || formData.n_for_type === undefined ||
      formData.n_to === null || formData.n_to === undefined ||
      (formData.n_for_type != 0 && (formData.n_for_id === "0" || formData.n_for_id === "" || formData.n_for_id === null || formData.n_for_id === undefined))
    ) {
      notification({ type: "error", message: "Please enter all required fields to submit", position: "top" })();
      return;
    }

    setOpenPreview(true);
  };

  const getYoutubeVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]{11}).*/;
    const match = url.match(regExp);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const imageTypes = ["png", "jpg", "jpeg", "gif", "webp"];
  const videoTypes = ["mp3", "wav", "ogg"];

  // --- Submit Handler ---
  const handleFormSubmit = async () => {
    try {
      setIsFormSubmit(true);
      let fData = new FormData();

      // Shared fields
      fData.append("n_type", formData.n_type);
      fData.append("n_send_to", formData.n_send_to);
      fData.append("n_for_type", formData.n_for_type);
      fData.append("n_to", formData.n_to);
      fData.append("n_for_id", formData.n_for_id);
      fData.append("n_status", formData.n_status);
      fData.append("n_link", formData.n_link || "");
      fData.append("n_button_title", formData.n_button_title || "");

      // Type-specific fields
      if (formData.n_type == 0 || formData.n_type == 1) {
        fData.append("n_title", formData.n_title);
        fData.append("n_description", formData.n_description);
        if (setfile?.file) fData.append("n_image", setfile.file);
      } else if (formData.n_type == 2) {
        fData.append("n_title", formData.n_title);
        fData.append("n_description", formData.n_description);
        fData.append("n_video", formData.n_video);
      } else if (formData.n_type == 3) {
        fData.append("n_question", formData.n_question);
        fData.append("n_answer", formData.n_answer);
      }

      // Schedule entries as JSON
      // Update API is ID-based: existing entries carry n_id (UPDATE),
      // new entries omit n_id (INSERT as new sub).
      const isEditPayload = formData.n_id != undefined;
      const schedulePayload = formData.schedule_entries.map((e) => {
        const obj = {
          s_date: e.s_date,
          e_date: e.e_date,
          notification_send_type: String(e.notification_send_type),
          n_date_time: e.n_date_time || "",
          show_on_home: e.show_on_home || 0
        };
        if (isEditPayload && e.n_id) obj.n_id = e.n_id;
        return obj;
      });
      fData.append("schedule_entries", JSON.stringify(schedulePayload));

      // Edit mode
      if (formData.n_id != undefined) {
        fData.append("n_id", formData.n_id);
        if (formData.linked_edit !== undefined) {
          fData.append("linked_edit", formData.linked_edit);
        }
        if (removeSubIds.length > 0) {
          fData.append("remove_sub_ids", JSON.stringify(removeSubIds));
        }
        const resp = await updateNotification(fData);
        notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message,
          position: "top"
        })();
        if (resp.status == 1) {
          resetForm();
          getNotificationList();
        }
      } else {
        // Add mode - batch insert
        const resp = await batchInsertNotification(fData);
        notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message,
          position: "top"
        })();
        if (resp.status == 1) {
          resetForm();
          getNotificationList();
        }
      }
    } catch (e) {
      console.log("Error", e);
    } finally {
      setIsFormSubmit(false);
      setOpenPreview(false);
    }
  };

  // --- Delete ---
  const handleDeleteClick = (row) => {
    const isMain = row.is_main === 1 || row.is_main === "1";
    if (isMain && row.parent_n_id == null) {
      // Count sub notifications from the list
      const subs = notificationList.filter(
        (n) => n.parent_n_id === row.n_id
      );
      if (subs.length > 0) {
        setDeletingRow(row);
        setSubCount(subs.length);
        setDeleteConfirmOpen(true);
        return;
      }
    }
    // Simple delete
    setDvisible({ mval: true, id: row.n_id });
  };

  const notificationdelete = async (n_id) => {
    const resp = await deleteNotification(n_id);
    notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message,
      position: "top"
    })();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };

  const handleConfirmDelete = async () => {
    if (!deletingRow) return;
    const resp = await deleteNotification(deletingRow.n_id);
    notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message,
      position: "top"
    })();
    if (resp.status == 1) {
      setresponse(response + 1);
      setDeleteConfirmOpen(false);
      setDeletingRow(null);
      setSubCount(0);
    }
  };

  // --- Edit ---
  const handleEditClick = async (row) => {
    await loadFormForEdit(row);
  };

  const loadFormForEdit = async (row) => {
    let entry = { ...row };
    const isSubNotification = row.parent_n_id && row.parent_n_id !== "" && row.parent_n_id !== null;
    // A sub row is read-only only once it has actually been sent; an unsent
    // sub row is editable like any other entry.
    const isSubSent = String(row.notification_send_status) === "1";
    setScheduleReadOnly(isSubNotification && isSubSent);
    setRemoveSubIds([]);
    setSiblingHasImmediate(false);

    // Only this row is loaded in the form, so check the rest of the batch to
    // find out whether an Immediate sibling already exists.
    if (isSubNotification) {
      try {
        const batchResp = await getNotificationByBatch(row.parent_n_id);
        if (batchResp.status === 1 && batchResp.data) {
          const otherImmediate = batchResp.data.some(
            (r) =>
              String(r.n_id) !== String(row.n_id) &&
              (String(r.notification_send_type) === "1" || r.notification_send_type === 1)
          );
          setSiblingHasImmediate(otherImmediate);
        }
      } catch (e) {
        console.error("Error fetching batch for send-type check:", e);
      }
    }

    try {
      if (isSubNotification) {
        entry.schedule_entries = [{
          s_date: row.s_date,
          e_date: row.e_date,
          notification_send_type: String(row.notification_send_type || "0"),
          n_date_time: row.n_date_time || "",
          show_on_home: row.show_on_home || 0,
          n_id: row.n_id,
          is_main: row.is_main || 0,
          notification_send_status: row.notification_send_status,
          _uid: `entry_${row.n_id}`
        }];
      } else {
        // Fetch full batch so every entry keeps its n_id (ID-based update).
        let batchRows = null;
        try {
          const batchResp = await getNotificationByBatch(row.n_id);
          if (batchResp.status === 1 && batchResp.data && batchResp.data.length > 0) {
            batchRows = [...batchResp.data].sort(
              (a, b) => (Number(b.is_main) === 1 ? 1 : 0) - (Number(a.is_main) === 1 ? 1 : 0)
            );
          }
        } catch (be) {
          console.error("Error fetching batch:", be);
        }
        if (batchRows) {
          entry.schedule_entries = batchRows.map((r) => ({
            s_date: r.s_date,
            e_date: r.e_date,
            notification_send_type: String(r.notification_send_type ?? "0"),
            n_date_time: r.n_date_time || "",
            show_on_home: r.show_on_home || 0,
            n_id: r.n_id,
            is_main: Number(r.is_main) === 1 ? 1 : 0,
            notification_send_status: r.notification_send_status,
            _uid: `entry_${r.n_id}`
          }));
        } else {
          const resp = await getNotificationChildren(row.n_id);
          const mainSchedule = {
            s_date: row.s_date,
            e_date: row.e_date,
            notification_send_type: String(row.notification_send_type || "0"),
            n_date_time: row.n_date_time || "",
            show_on_home: row.show_on_home || 0,
            n_id: row.n_id,
            is_main: 1,
            notification_send_status: row.notification_send_status,
            _uid: `entry_${row.n_id}`
          };
          const subEntries =
            resp.status === 1 && resp.data
              ? resp.data.map((r) => ({
                s_date: r.s_date,
                e_date: r.e_date,
                notification_send_type: String(r.notification_send_type || "0"),
                n_date_time: r.n_date_time || "",
                show_on_home: r.show_on_home || 0,
                n_id: r.n_id,
                is_main: 0,
                notification_send_status: r.notification_send_status,
                _uid: `entry_${r.n_id}`
              }))
              : [];
          entry.schedule_entries = [mainSchedule, ...subEntries];
        }
      }
    } catch (e) {
      console.error("Error fetching children:", e);
    }

    entry.linked_edit = "1";

    setFormData(entry);
    setPage(2);
    setfileimage();
  };

  // --- Read Notification Modal ---
  const openModalWithNotification = async (n_id) => {
    setReadNotificationDataModal(true);
    try {
      setIsLoading2(true);
      const resp = await getReadNotificationData(n_id);
      setIsLoading2(false);
      if (resp.status === 1) {
        setReadNotificationList(resp.data);
      } else {
        setReadNotificationList([]);
      }
    } catch (error) {
      console.error("Error fetching notification data:", error);
      setIsLoading2(false);
    }
  };

  // --- Helpers ---
  const resetForm = () => {
    setFormData(getDefaultFormData());
    setPage(0);
    setfileimage();
    setFile({});
    setScheduleReadOnly(false);
    setRemoveSubIds([]);
    setSiblingHasImmediate(false);
  };

  function htmlToPlainText(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleScheduleEntryRemove = (nId) => {
    setRemoveSubIds((prev) => [...prev, nId]);
  };

  const formattedCSVData = notificationList.map((row) => ({
    n_id: row.n_id,
    Notification_type: row.Notification_type,
    n_title: row.n_title,
    n_description: htmlToPlainText(row.n_description || ""),
    n_link: row.n_link,
    n_button_title: row.n_button_title,
    n_question: row.n_question,
    n_answer: row.n_answer || "",
    Notification_Send_To: row.Notification_Send_To,
    Notification_For: row.Notification_For,
    Notification_To: row.Notification_To,
    s_date: row.s_date,
    e_date: row.e_date,
    n_date_time: row.n_date_time,
    timestamp: formatDate(row.timestamp)
  }));

  const expo_columns = [
    { label: "No", key: "n_id" },
    { label: "Type", key: "Notification_type" },
    { label: "Title", key: "n_title" },
    { label: "Description", key: "n_description" },
    { label: "URL", key: "n_link" },
    { label: "Button Title", key: "n_button_title" },
    { label: "Question", key: "n_question" },
    { label: "Answer", key: "n_answer" },
    { label: "Notification Send To", key: "Notification_Send_To" },
    { label: "Notification For", key: "Notification_For" },
    { label: "Notification To", key: "Notification_To" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" },
    { label: "Notification Send Date & Time", key: "n_date_time" },
    { label: "Created Date", key: "timestamp" }
  ];

  // --- Render ---
  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={notificationdelete} />
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => {
          setDeleteConfirmOpen(false);
          setDeletingRow(null);
          setSubCount(0);
        }}
        onConfirm={handleConfirmDelete}
        subCount={subCount}
      />

      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Confirm Notification</DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle2" gutterBottom>Schedule Entries ({formData.schedule_entries?.length || 0})</Typography>
          {formData.schedule_entries?.map((entry, idx) => (
            <div key={idx} style={{ marginBottom: 8, padding: 8, background: "#f5f5f5", borderRadius: 4 }}>
              <Typography variant="body2">
                <strong>Entry {idx + 1}:</strong>{" "}
                {entry.notification_send_type == 1
                  ? "Send Immediately"
                  : `${entry.s_date || "—"} to ${entry.e_date || "—"}${entry.n_date_time ? ` @ ${entry.n_date_time}` : ""}`}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Show on Home: {entry.show_on_home ? "Yes" : "No"}
              </Typography>
            </div>
          ))}
          {formData.n_for_type != 0 && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              <strong>Target:</strong> {formData.n_for_id?.split(",").filter(v => v !== "0").length || 0} selected
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPreview(false)}>Cancel</Button>
          <Button variant="contained" color="primary" disabled={isFormSubmit} onClick={handleFormSubmit}>
            {isFormSubmit ? "Submitting..." : "Confirm & Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Page title="Notification | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom className="mb-0">
              Notification
            </Typography>
            {page === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setFormData(getDefaultFormData());
                  setPage(1);
                  setIsFormSubmit(false);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Notification
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                disabled={isFormSubmit}
                onClick={resetForm}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {page !== 0 ? (
            <NotificationForm
              formData={formData}
              setFormData={setFormData}
              page={page}
              onSubmit={validationHandler}
              onCancel={resetForm}
              isFormSubmit={isFormSubmit}
              setFile={setFile}
              fileimage={fileimage}
              setfileimage={setfileimage}
              loginUser={loginUser}
              scheduleReadOnly={scheduleReadOnly}
              onScheduleEntryRemove={handleScheduleEntryRemove}
              sentLocked={String(formData?.notification_send_status) === "1"}
              siblingHasImmediate={siblingHasImmediate}
            />
          ) : (
            <>
              <NotificationFilters
                filtereddata={filtereddata}
                setFilteredData={setFilteredData}
                loginUser={loginUser}
              />
              <div style={{ padding: "15px 0" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={formattedCSVData}
                    headers={expo_columns}
                    filename={"Notification.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {notificationList && (
                  <NotificationTable
                    data={notificationList}
                    isLoading={isLoading}
                    loginUser={loginUser}
                    onDelete={handleDeleteClick}
                    onEdit={handleEditClick}
                    onViewRead={openModalWithNotification}
                    pagination={pagination}
                    onPageChange={handlePageChange}
                    onPerRowsChange={handlePerRowsChange}
                  />
                )}
              </div>
            </>
          )}

          <ReadNotificationModal
            open={readNotificationDataModal}
            onClose={() => {
              setReadNotificationDataModal(false);
              setReadNotificationList([]);
            }}
            data={readNotificationList}
            isLoading={isLoading2}
          />
        </Container>
      </Page>
    </>
  );
}

export default Notification;
